import React from 'react';
import { ExternalLink, UtensilsCrossed, FileText } from 'lucide-react';

const Menu = () => {
  const menuHighlights = [
    {
      category: 'Pizzas',
      description: 'Nuestras famosas pizzas a la parrilla',
      items: ['Muzzarella', 'Napolitana', 'Fugazzeta', 'Especiales'],
    },
    {
      category: 'Picadas',
      description: 'Para compartir entre amigos',
      items: ['Picada Clásica', 'Picada Premium', 'Tabla de Fiambres'],
    },
    {
      category: 'Bebidas',
      description: 'Cervezas y más',
      items: ['Cervezas Artesanales', 'Tiradas', 'Vinos', 'Tragos'],
    },
    {
      category: 'Platos',
      description: 'Cocina de pub',
      items: ['Hamburguesas', 'Papas', 'Empanadas', 'Y más...'],
    },
  ];

  return (
    <section id="carta" className="py-16 md:py-24 bg-[#0d0d0d]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#7cb342]/10 px-4 py-2 rounded-full mb-4">
            <UtensilsCrossed size={18} className="text-[#7cb342]" />
            <span className="font-body text-sm text-[#7cb342] uppercase tracking-wider">Nuestra Carta</span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Descubrí lo que <span className="text-[#7cb342]">Te Espera</span>
          </h2>
          <p className="font-body text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">
            Desde nuestras icónicas pizzas a la parrilla hasta picadas abundantes para compartir.
          </p>
        </div>

        {/* Menu Highlights Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {menuHighlights.map((section, index) => (
            <div 
              key={index}
              className="card-hover bg-[#1a1a1a] rounded-xl p-6 border border-[#252525]"
            >
              <h3 className="font-heading text-xl font-semibold text-[#7cb342] mb-2">
                {section.category}
              </h3>
              <p className="font-body text-gray-500 text-sm mb-4">
                {section.description}
              </p>
              <ul className="space-y-2">
                {section.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-[#7cb342] rounded-full" />
                    <span className="font-body text-gray-300 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://drive.google.com/file/d/1example/view"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary flex items-center gap-2 px-8 py-4 rounded-lg font-heading uppercase tracking-wider font-semibold w-full sm:w-auto justify-center"
          >
            <FileText size={20} />
            Ver Menú Completo
          </a>
          <a
            href="https://bit.ly/4cyMld9"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline flex items-center gap-2 px-8 py-4 rounded-lg font-heading uppercase tracking-wider font-semibold w-full sm:w-auto justify-center"
          >
            <ExternalLink size={20} />
            Pedir por Pedidos Ya
          </a>
        </div>
      </div>
    </section>
  );
};

export default Menu;
